export default __webpack_public_path__ + "static/media/exclamation.dbed2ad7.svg";